(function($j) {
    $j(function() {
        var forgotPasswordForm = $j('#caSignInForgotPasswordForm');
        if (!forgotPasswordForm.length) return; // for sign-in pages without this form

        forgotPasswordForm.validateForm({
            rules: {
                email: {
                    required: true,
                    email: true
                }
            },
            messages: {
                email: 'The email address must be in the format of @domain.com.'
            },
            submitHandler: function() {
                var formContainer = $j('.forgot-password-form-container');
                var submitButton = $j('#submitButton');

                if (formContainer.data('caUi-globalError')) {
                    formContainer.globalError('destroy');
                }

                submitButton
                    .buttonState()
                    .buttonState('loading');

                $j.post(
                        '/forgot-password/process', {
                            email: $j('#email').val()
                        }
                    )
                    .done(function(data) {
                        if (data.status === 1) {
                            window.location.href = '/forgot-password/success';
                        } else {
                            submitButton.buttonState('default');

                            if (data.message) {
                                formContainer.globalError({
                                    errorMessage: data.message
                                });
                            } else {
                                formContainer.globalError();
                            }
                        }
                    })
                    .fail(function() {
                        submitButton.buttonState('default');
                        formContainer.globalError();
                    });
            }
        });
    });
})(jQuery);
